







































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import Auth from '@aws-amplify/auth';

@Component
export default class ConfirmEmail extends Vue {

  // the Cognito User Object
  @Getter('auth/cognitoUser') public cognitoUser: any;

  public error: string;

  public code: string;
  public currentyear: number = new Date().getFullYear();


  public created() {
    this.error = '';
    this.code = '';
  }

  public confirmSignIn() {
    this.error = '';
    Auth.confirmSignIn(this.cognitoUser, this.code, 'SOFTWARE_TOKEN_MFA')
      .then((response: any) => {
        // console.log('response', response);
        // this.$router.push({name: 'reports'});
      })
      .catch((err: any) => this.$onecentral.displayError(err));
  }
}
